import Vue from "vue";
import Router from "vue-router";
// import axios from "axios";
import store from "./store";
Vue.use(Router);
let router = new Router({
   mode: "history",
   routes: [
      {
         path: '/',
         component: () => import('./components/layouts/loginLayout'),
         meta: {
            requiresAuth: false,
         },
         children: [
            {
               path: '/',
               name: 'loginPage',
               component: () => import('./views/login/loginPage'),
                meta: {
                  requiresAuth: false,
               },
            },
            {
               path: '/forgotPassword',
               name: 'forgotPassword',
               component: () => import('./views/login/forgotPassword'),
                meta: {
                  requiresAuth: false,
               },
            },
            {
               path: '/otpVerification',
               name: 'otpVerification',
               component: () => import('./views/login/otpVerification'),
                meta: {
                  requiresAuth: false,
               },
            },
            {
               path: '/newPassword',
               name: 'newPassword',
               component: () => import('./views/login/newPassword'),
                meta: {
                  requiresAuth: false,
               },
            },
         ],
      },
      {
         path: '/dashboard',
         component: () => import('./components/layouts/dashboardLayout'),
         meta: {
            requiresAuth: true,
         },
         children: [
            {
               path: '/',
               name: 'Dashboard',
               component: () => import('./views/homePage'),
               meta: {
                  requiresAuth: true,
               },
            },
            {
               path: '/questionbank',
               name: 'Question Bank',
               component: () => import('./views/questions/questionBank'),
               meta: {
                  requiresAuth: true,
               },
            },
            {
               path: '/survey',
               name: 'Survey',
               component: () => import('./views/survey/surveyPage'),
               meta: {
                  requiresAuth: true,
               },
            },
            {
               path: '/createSurveyold',
               name: 'Create Surveyold',
               component: () => import('./views/survey/createSurvey'),
               meta: {
                  requiresAuth: true,
               },
            },
            {
               path: '/createSurvey2',
               name: 'Create Survey',
               component: () => import('./views/survey/createSurvey/createSurvey'),
               meta: {
                  requiresAuth: true,
               },
            },
            {
               path: '/createSurvey',
               name: 'Create Survey',
               component: () => import('./views/survey/createSurveyNew/createSurvey'),
               meta: {
                  requiresAuth: true,
               },
            },
            {
               path: '/viewSurveyDetails',
               name: 'Survey Details',
               component: () => import('./views/survey/viewSurveys'),
               meta: {
                  requiresAuth: true,
               },
            },
            {
               path: '/editSurvey',
               name: 'Edit Survey',
               component: () => import('./views/survey/editSurvey/createSurvey'),
               meta: {
                  requiresAuth: true,
               },
            },
            {
               path: '/viewUser',
               name: 'View User',
               component: () => import('./views/survey/viewUser'),
               meta: {
                  requiresAuth: true,
               },
            },
            {
               path: '/reports',
               name: 'Reports',
               component: () => import('./views/reportPage'),
               meta: {
                  requiresAuth: true,
               },
            },
            {
               path: '/users',
               name: 'Users',
               component: () => import('./views/users/viewUsers'),
               meta: {
                  requiresAuth: true,
               },
            },
            {
               path: '/notifications',
               name: 'Notifications',
               component: () => import('./views/notifications/notificationPage'),
               meta: {
                  requiresAuth: true,
               },
            },
            {
               path: '/rewardStore',
               name: 'Reward Store', 
               component: () => import('./views/rewardStore/rewardStore'),
               meta: {
                  requiresAuth: true,
               },
            },
            {
               path: '/testPage',
               name: 'testPage',
               component: () => import('./views/rewardStore/testPage'),
               meta: {
                  requiresAuth: true,
               },
            },

         ],
      },
      {
         path: '/newtestPage',
         name: 'newtestPage',
         component: () => import('./views/newtestPage'),
          meta: {
            requiresAuth: false,
         },
      },

   ],
   scrollBehavior() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
   },
});

router.beforeEach((to, from, next) => {
   localStorage.setItem("PRE", from.path);
   if (to.name === "Create Survey") {
      // Set generateQuestion to true and clear questionsByType
      store.dispatch("updateGenerateQuestion", false);
      store.dispatch("clearQuestionsByType");
    } else if (from.name === "Create Survey") {
      // Set generateQuestion to false and clear questionsByType
      store.dispatch("updateGenerateQuestion", false);
      store.dispatch("clearQuestionsByType");
    }
   if (
      to.matched.some((route) => route.meta.requiresAuth === true) &&
      store.state.isLoggedIn == false
   ) {
      next({ name: "loginPage", params: { lastPage: from } });
      return;
   }
   if (to.name === "loginPage" && store.state.isLoggedIn == true) {
      next({ name: "Dashboard" });
   }
   const resolved = router.resolve(to.path);
   if (!resolved.route.matched.length) {
     if (store.state.isLoggedIn) {
       next({ name: "Dashboard" });
     } 
     return;
   }
   if (from.name === "Create Survey2" && to.name !== "Create Survey2") {
      store.dispatch("resetTabData"); // Reset Vuex tab data
    }
   next();
});

export default router;